class Eez extends Array {}

const eez_api_adapter = eez => eez;

const eez_list_api_adapter = eez => eez.map(eez_api_adapter);

const createEezList = (data = []) => {
    const eez = Eez.from(data, eez => createEez(eez));
    return eez;
};

const eez_view_adapter = eez => {
    return eez;
};

const createEez = ({
    id = null,
    country = null,
    area_km2 = null,
    political = null,
    authority = null,
    more_info = null,
    geom = null,
} = {}) => {
    const publicApi = {
        id,
        country,
        area_km2,
        political,
        authority,
        more_info,
        geom,
    };

    return Object.freeze(publicApi);
};

export {
    createEez,
    createEezList,
    eez_api_adapter,
    eez_list_api_adapter,
    eez_view_adapter,
};
